module.exports = __webpack_public_path__ + "static/media/short-circuit_shells_logos.9c9116a9.png";